export { TableHead, TableBody, TableRow } from '@material-ui/core';
export { default as Table } from './Table';
export { default as TableCell } from './TableCell';



// WEBPACK FOOTER //
// ./src/components/Table/index.ts